import React, { FunctionComponent, memo } from 'react';
import { Box, Typography } from '@material-ui/core';
import Price from '../../../../../../common/components/presentation/Price';
import dealPriceAccessor from '../../../../../../common/service/dealPriceAccessor';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import { IPrices } from '../../../../../../../../common/model/IPrice';
import optionPriceSingleCurrencyStyles from './optionPriceSingleCurrencyStyles';
import clsx from 'clsx';
import ShowIfTranslationExists from '../../../../../../common/components/ShowIfTranslationExists';
import Translation from '../../../../../../common/components/translation/Translation';

export interface IOptionPriceSingleCurrencyProps {
  prices: IPrices;
  display: {
    optionPriceLabel?: boolean;
  };
  classes: {
    priceText: string | undefined;
  };
}

const OptionPriceSingleCurrency: FunctionComponent<IOptionPriceSingleCurrencyProps> = memo(
  ({ prices, display: { optionPriceLabel = false }, classes }) => {
    const styles = optionPriceSingleCurrencyStyles();
    const {
      platformConfig: { priceDisplay },
    } = usePlatformConfig();
    const primaryPrice = dealPriceAccessor.getPrimaryPrice(prices, priceDisplay);

    return (
      <Box display="flex">
        {optionPriceLabel && (
          <Typography
            className={clsx([styles.accessoryPriceContent, styles.accessoryPriceLabel])}
            data-test="option:price:label"
          >
            <Translation id="spc.customise.accessories.accessoryPriceLabel" />
          </Typography>
        )}
        <Price
          className={clsx([styles.accessoryPriceContent, classes?.priceText])}
          price={primaryPrice?.basePrice}
          currency={priceDisplay.primaryOptions.currency}
          decimals={priceDisplay.primaryOptions.decimalScale}
          data-test={'option:price:primary'}
        />
        <ShowIfTranslationExists translationKey="spc.customise.accessories.accessoryPriceSecondaryLabel">
          <Typography className={clsx([styles.accessoryPriceContent, styles.accessoryPriceSecondaryLabel])}>
            <Translation id="spc.customise.accessories.accessoryPriceSecondaryLabel" />
          </Typography>
        </ShowIfTranslationExists>
      </Box>
    );
  },
);

export default OptionPriceSingleCurrency;
